import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

export interface IQuestionMain {
  redbr: number;
  main_combination_id: string;
  main_question_id_record: number;
  question_text: string;
  question_answer1: string;
  question_answer2: string;
  question_answer3: string;
  question_answer4: string;
}

const questionMain = async (
  redBr: number,
  combId: string
): Promise<IQuestionMain | boolean> => {
  try {

    const config: AxiosRequestConfig = {
      method: "POST",
      // url: `${process.env.REACT_APP_HOST}/ultra3/add-entry`, http://ultra-cib.malihetz.complete-inbox.com
      // url: `https://quiz-back.firebird.rs/api/ultra/question-main`,
      
      // Lokalno (development)
      // url: `http://localhost:6002/api/ultra/question-main`,
      
      // Produkcija
      url: `https://politehnika-back.firebird.rs/api/ultra/question-main`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        redBr: redBr,
        combId: combId,
      },
    };
    const response: AxiosResponse = await axios(config);
    const { data } = response.data;

    return data;
  } catch (error) {

    return false;
  }
};

export default questionMain;
